<template>
    <div class="Stockpurchase">
        <el-form
            :model="formScreen"
            ref="formScreen"
            label-width="100px"
            style="overflow: hidden;"
            class="border-bottom margin-top2"
        >
            <el-col :span="6">
                <el-form-item label="采购状态" prop="purchaseStatus">
                    <el-select v-model="formScreen.purchaseStatus" placeholder="请选择">
                        <el-option
                            v-for="item in OrderList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        v-model="formScreen.startTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        v-model="formScreen.endTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item prop="searchString">
                    <el-row type="flex" justify="space-between" align="middle">
                        <el-input
                            v-model="formScreen.searchString"
                            placeholder="全称 | 简称 | 库存编号 | 国内运单"
                            @change="search"
                            style="margin-right:10px;"
                        ></el-input>
                        <el-button type="primary" @click="search">搜索</el-button>
                        <el-button type="primary" @click="resetFprm('formScreen')">重置</el-button>
                    </el-row>
                </el-form-item>
            </el-col>
        </el-form>
        <el-table :data="listTable" border v-loading="loading">
            <el-table-column prop="inventoryNumber" width="200" label="库存编号" align="center">
              <template slot-scope="scope">
                <div>库存号:{{ scope.row.inventoryNumber }}</div>
                <div>批次号:{{ scope.row.inventoryBatchNo }}</div>
                <el-row type="flex" justify="start" v-if="scope.row.checkResult === 2">
                  <el-tag size="mini" type="danger" effect="dark">异常</el-tag>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <!-- <div>
                        {{scope.row.imagesList.length}}
                    </div> -->
                    <el-popover v-if="scope.row.imagesList != null" trigger="hover" placement="right" style="float: left;">
                        <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
                        <div class="scope_img" slot="reference">
                            <img :src="scope.row.imagesList[0]" alt />
                        </div>
                    </el-popover>
                    <div v-else>
                        暂无图片
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="productFullName" width="200" label="全称" align="center"></el-table-column>
            <el-table-column prop="productSimpleName" width="200" label="简称" align="center"></el-table-column>
            <el-table-column prop="productDescription" width="200" label="描述" align="center"></el-table-column>
            <el-table-column width="200" label="国内运单" align="center">
                <template slot-scope="scope">
                    <el-popover 
                        placement="top" 
                        width="800" 
                        trigger="click" 
                        :open-delay="1000"
                        @show="popoverShow(scope.row)">
                        <template>
							<div style="width: 100%;text-align: center;" v-if="popoverStatus">
								{{ popoverText }}
							</div>
							<div style="width: 100%;" v-else>
								<div v-if="popoverInfo.number" style="margin-bottom: 10px;">
									<span>运单号：{{
										popoverInfo.number
									}}</span>
									<span style="margin-left: 10px;">{{
										popoverInfo.track_info.latest_status.status
									}}</span>
								</div>
								<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
									<span>时效信息: </span>
									<span style="margin-left: 10px;">订单:{{
										popoverInfo.track_info.time_metrics.days_after_order
									}}天</span>
									<span style="margin-left: 10px;">运输:{{
										popoverInfo.track_info.time_metrics.days_of_transit
									}}天</span>
									<span style="margin-left: 10px;">妥投:{{
										popoverInfo.track_info.time_metrics.days_of_transit_done
									}}天</span>
									<span style="margin-left: 10px;">无更新:{{
										popoverInfo.track_info.time_metrics.days_after_last_update
									}}天</span>
								</div>
								<div v-if="popoverInfo.track_info"
												style="height: 200px;overflow: auto;">
									<div v-for="(item, index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 5px;">
                                        <div>{{ item.description }}</div>
                                        <div>{{ timeConversion(item.time_iso) }}</div>
									</div>
								</div>
							</div>
						</template>

                        <template slot="reference">
                            <el-row type="flex" justify="center" align="middle">
                                <div style="cursor: pointer;">
                                    <span>
                                        {{scope.row.internalConveyNumber}}
                                    </span>
                                </div>
                            </el-row>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column width="100" label="采购状态" align="center">
                <template slot-scope="scope">
                    <span style="color: red;" v-if="scope.row.purchaseStatus === 0">待采购</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 1">已采购</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 2">已发货</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 3">已签收</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 4">退货</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 5">已入库</span>
                    <span style="color: #0565b7;" v-else-if="scope.row.purchaseStatus === 6">已完成</span>
                </template>
            </el-table-column>
            <el-table-column prop="predictCount" width="80" label="数量" align="center"></el-table-column>
            <el-table-column prop="purchasePrice1" width="80" label="采购价" align="center"></el-table-column>
            <el-table-column prop="createTime" width="200" label="申请时间" align="center"></el-table-column>
            <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
            <el-table-column prop="roleName" width="80" label="申请人" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="edit(scope.row)">采购编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <Stockpurchaseedit ref="Stockpurchaseedit" @confirm="stockpurchaseeditConfirm" />
    </div>
</template>

<script>
import Stockpurchaseedit from "./Stockpurchaseedit/Stockpurchaseedit";
import { Baseurl, ajaxPost } from "@/api/api/api";
export default {
    name: "Stockpurchase",
    components: {
        Stockpurchaseedit,
    },
    data() {
        return {
            page: 1,
            size: 20,
            total: 0,
            loading:false,
            formScreen: {
                purchaseStatus: "",
                startTimeString: "",
                endTimeString: "",
                searchString: "",
            },
            listTable: [],
            UserInfo: {},
            OrderList: [
                {
                    value: 0,
                    label: "待采购",
                },
                {
                    value: 1,
                    label: "已采购",
                },
                {
                    value: 2,
                    label: "已发货",
                },
                {
                    value: 3,
                    label: "已签收",
                },
                {
                    value: 4,
                    label: "退货",
                },
            ],
            popoverStatus: true,
            popoverText: '查询中...',
            popoverInfo: null,
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getListTable();
    },
    methods: {
        // 时间转换
		timeConversion(item){
			const date = new Date(item);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');
			const formattedTime = `${year}/${month}/${day} ${hour}:${minute}:${seconds}`
			return formattedTime
		},
        edit(row) {
            this.$refs.Stockpurchaseedit.init(row);
        },
        resetFprm(formName) {
            this.page = 1
            this.$refs[formName].resetFields();
            this.getListTable();
        },
        handleSizeChange(val) {
            
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.getListTable();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            this.getListTable();
        },
        search(){
            this.page = 1
            this.getListTable()
        },
        getListTable() {
            this.loading = true;
            const API = Baseurl + "inventoryController/selectInventoryBatchList";
            const paramsData = {
                companyId: this.UserInfo.company_id,
                page: this.page,
                size: this.size,
                ...this.formScreen,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.total = data.total;
                    this.listTable = data.list;
                    // console.log(this.listTable)
                }
                this.loading = false
            });
        },
        stockpurchaseeditConfirm(data) {
            const API = Baseurl + "purchaseController/insertPurchase";
            const paramsData = {
                purchaseFrom: "2",
                companyId: this.UserInfo.company_id,
                purchaseRoleId: this.UserInfo.rid,
                roleId: this.UserInfo.rid,
                ...data,
            };
          
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.$refs.Stockpurchaseedit.close();
                    this.getListTable();
                    this.$message.success("操作成功");
                }else{
                    this.$message.error(res.data.data)
                }
            });
        },
        async popoverShow(item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
            const queryTrackSwitch = this.UserInfo.company.queryTrackSwitch
			try {
                if(queryTrackSwitch === 1) {
                    // 快递100物流轨迹查询
                    // const data = await this.queryDomesticOrderMove(item)
                    // if (data.status === '200') {
                    //     this.popoverStatus = false
                    //     this.popoverInfo = data
                    // } else {
                    //     this.popoverText = data.message || '查询失败'
                    // }
                    const data = await this.query17Trackinfo(item)  // 17track物流轨迹查询
                    if (data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
						this.popoverStatus = false
						this.popoverInfo = data.data.accepted[0]
					} else if (data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
					} else {
						this.popoverText = data.message || '查询失败'
					}
                } else {
                    this.popoverText = '贵司尚未开启物流轨迹查询!'
                }
				
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
        query17Trackinfo(item) {
			const API = Baseurl + 'track17Controller/gettrackinfo'
			const paramsDate = [{
				number: item.internalConveyNumber,
				carrier: !isNaN(item.companyCode) ? item.companyCode : null,
			}]
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
        queryDomesticOrderMove(item) {
			const API = Baseurl + 'conveyNumberQueryController/queryTrack'
			const paramsDate = {
				num: item.internalConveyNumber,
				companyId: item.companyId,
				com: item.companyCode,
			}
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
						// console.log(data)
					} else {
						reject(data)
					}
				})
			})
		},
    },
};
</script>

<style lang="scss" scoped>
.Stockpurchase {
    width: 98%;
    overflow: hidden;
    padding-bottom: 72px;
    .pagination-container {
        width: 1660px;
        padding: 20px;
        position: fixed;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 999;
        .el-pagination {
            display: flex;
            justify-content: center;
        }
    }
}
.scope_img {
    img {
        width: 100px;
        height: 100px;
    }
}
.line-height {
    line-height: 45px;
}
.prduct_img {
    width: 500px;
    height: 500px;
}
</style>
